// We importeren React en de useState-hook om gegevens op te slaan binnen deze component
import React, { useState } from "react";
// We importeren de drie hoofdcomponenten van onze applicatie
import Login from "./Login";
import Register from "./Register";
import DefensiveAction from "./components/DefensiveAction.jsx";

// Dit is de hoofdcomponent van de applicatie
export default function App() {
  // 🔹 gebruiker: bevat de naam van de ingelogde gebruiker
  // Als gebruiker = null, is niemand ingelogd
  const [gebruiker, setGebruiker] = useState(null);

  // 🔹 showRegister: bepaalt of we het login- of registratieformulier tonen
  const [showRegister, setShowRegister] = useState(false);

  // 🧠 Als er nog GEEN gebruiker is ingelogd:
  if (!gebruiker) {
    // We controleren of de gebruiker het registratieformulier moet zien
    return showRegister ? (
      // 👉 Als showRegister true is: toon het registratieformulier
      <Register
        // Zodra iemand zich succesvol registreert, keren we terug naar het login-scherm
        onRegistered={() => setShowRegister(false)}
        // Als iemand op “Log in” klikt, tonen we weer de loginpagina
        onSwitchToLogin={() => setShowRegister(false)}
      />
    ) : (
      // 👉 Als showRegister false is: toon het loginformulier
      <Login
        // Zodra iemand succesvol inlogt, slaan we de gebruikersnaam op in "gebruiker"
        onLogin={setGebruiker}
        // Als iemand op “Meld je aan” klikt, tonen we het registratieformulier
        onSwitchToRegister={() => setShowRegister(true)}
      />
    );
  }

  // 🧠 Als er WEL een gebruiker is ingelogd:
  // We tonen het dashboard met een welkomstbericht en de grafiekcomponent
  return (
    <div className="p-6">
      {/* Bovenste balk met welkomsttekst en uitlogknop */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Welkom, {gebruiker}!</h1>

        {/* Uitlogknop: zet gebruiker terug op null zodat het login-scherm weer verschijnt */}
        <button
          onClick={() => setGebruiker(null)}
          className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
        >
          Uitloggen
        </button>
      </div>

      {/* De hoofdinhoud: onze grafiekcomponent met verdedigende acties */}
      <DefensiveAction />
    </div>
  );
}
